import {
  getChannelObj,
  getChannelColorNameAndIcon,
  getTranslatedChannels,
  channels,
} from '@/utils/channels';

export default {
  data() {
    return {
      fourBigChannels: [
        'instagram',
        'facebook',
        'twitter',
        'youtube',
      ],
      channelsList: {},
    };
  },
  computed: {
    channels() {
      return channels;
    },
  },
  created() {
    this.channelsList = getTranslatedChannels();
  },
  methods: {
    getChannelObj(title) {
      return getChannelObj(title);
    },
    getChannelColorNameAndIcon(title) {
      return getChannelColorNameAndIcon(title);
    },
  },
};
